import React from "react";

export default function MSAccess_Chr() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Chr</h1>
      <p>This is the MSAccess_Chr component generated from the SQL JSON.</p>
    </div>
  );
}
